// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c3fcbb5","665":"75494207"}[chunkId] + ".chunk.js";
};